import React from 'react';
import Editor from './components/Editor';
import './App.css';

function App() {
  return (
    <>
    <h1>Tiptap Editor with Custom Url Shortener Ex</h1>
    <div>
      <Editor />
    </div>
    </>
  );
}

export default App;
